import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function disableSending (clientId) {
    return axios.put(`${CRM_API_URL}/clients/${clientId}/sms/disable`).then(response => response.data)
}

function enableSending (clientId) {
    return axios.put(`${CRM_API_URL}/clients/${clientId}/sms/enable`).then(response => response.data)
}

export default { disableSending, enableSending }
